var _circle, _circle2, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEllipses = function SvgEllipses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1842,
    height: 1842,
    fill: "none",
    viewBox: "0 0 1842 1842"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 921,
    cy: 921,
    r: 737,
    stroke: "url(#ellipses_paint0_linear_3162_65733)",
    strokeWidth: 2,
    opacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 921,
    cy: 921,
    r: 532,
    stroke: "url(#ellipses_paint1_linear_3162_65733)",
    strokeWidth: 2,
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 921,
    cy: 921,
    r: 920,
    stroke: "url(#ellipses_paint2_linear_3162_65733)",
    strokeWidth: 2,
    opacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ellipses_paint0_linear_3162_65733",
    x1: 921,
    x2: 921,
    y1: 183,
    y2: 1659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ellipses_paint1_linear_3162_65733",
    x1: 921,
    x2: 921,
    y1: 388,
    y2: 1454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ellipses_paint2_linear_3162_65733",
    x1: 921,
    x2: 921,
    y1: 0,
    y2: 1842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E1E3EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#E1E3EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#E1E3EF",
    stopOpacity: 0
  })))));
};
export default SvgEllipses;